import { Component, computed, Input, OnChanges, Signal, signal, SimpleChanges, ViewEncapsulation, WritableSignal } from '@angular/core';
import { ViewStock } from 'src/app/models/enums/ViewStock.enum';
import { StockDTO, StocksDTO, StoreStock, StoreStocks } from 'src/app/models/types/Product/Stock.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { AuthService } from 'src/app/services/auth.service';
import { MyStoreStockComponent } from './my-store-stock/my-store-stock.component';
import { OtherStoreStockComponent } from './other-store-stock/other-store-stock.component';
@Component({
  selector: 'app-view-stock',
  imports: [MyStoreStockComponent, OtherStoreStockComponent, SharedModule],
  templateUrl: './view-stock.component.html',
  styleUrl: './view-stock.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ViewStockComponent implements OnChanges {

  @Input('viewStockType') viewStockType!: ViewStock;
  @Input('stock') stock!: StocksDTO;
  @Input('sapCode') sapCode!: string;

  private _storeStock: WritableSignal<StoreStock | null> = signal(null);
  public storeStock: Signal<StoreStock | null> = computed(() => this._storeStock());

  private _otherStoreStock: WritableSignal<StoreStocks> = signal([]);
  public otherStoreStock: Signal<StoreStocks> = computed(() => this._otherStoreStock());

  public get isViewMyStoreType(): boolean {
    return this.viewStockType === ViewStock.ViewMyStore;
  }

  public get isViewOtherStoreType(): boolean {
    return this.viewStockType === ViewStock.ViewOtherStore;
  }

  constructor(
    private readonly authService: AuthService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isViewMyStoreType) {
      this.setMyStoreStock()
    }
    if (this.isViewOtherStoreType) {
      this.setOtherStoreStock();
    }
  }

  setMyStoreStock() {
    let productStock = this.stock.find(stock => stock.sapcode === this.sapCode) || null;
    if (productStock && productStock.storeStocks) {
      let storeStock = productStock.storeStocks.find(stock => stock.myStore);
      this._storeStock.set(storeStock || null);
    } else {
      this._storeStock.set(null);
    }
  }

  setOtherStoreStock() {
    let productStock = this.stock.find(stock => stock.sapcode === this.sapCode) || null;
    if (productStock && productStock.storeStocks) {
      this._otherStoreStock.set(productStock.storeStocks.filter(stock => !stock.myStore));
    } else {
      this._otherStoreStock.set([]);
    }
  }
}
